import React from "react";
import { HashLink } from "react-router-hash-link";
import Scrollspy from "react-scrollspy";
//
function ArchiveStickySelector({ years }) {
  return (
    <div className="whitespace-no-wrap text-right">
      <Scrollspy
        className="inline-block"
        items={years}
        currentClassName="transition-colors duration-200 line-through text-hugeorange"
      >
        {years.map((year) => {
          return (
            <div key={year} className="origin-center transform rotate-90">
              <HashLink
                smooth
                to={"/Archive#" + year}
                className="h6 inline-block my-8"
              >
                {year}
              </HashLink>
            </div>
          );
        })}
      </Scrollspy>
    </div>
  );
}

export default ArchiveStickySelector;
